module.exports = __webpack_public_path__ + "img/qianzi.8e696409.png";